/**
 * Core function for logarithmic accelerating shape
 * f(x) = -2e^(x/2) + 2
 */
export function calculateLogAccel(x: number): number {
  return -2 * Math.exp(x / 2) + 2;
}

export interface LogAccelInterval {
  a: number;
  b: number;
}

export interface LogAccelBuild {
  id: string;
  interval: LogAccelInterval;
}
